/* eslint-disable jsx-a11y/aria-role */

import { RecipientBadge } from './RecipientBadge';
import { getSender } from './utils';

interface SenderInfoProps {
  sender: ReturnType<typeof getSender> | null;
}

export const SenderInfo = ({ sender }: SenderInfoProps) => {
  if (!sender) return null;
  return (
    <RecipientBadge
      recipient={sender}
      recipientRole="from"
      size="sm"
      showAvatar={false}
      showRole={false}
      inline
      primary
    />
  );
};
